import type {
    SignalNameSelectionOverflow,
    SignalNameSelectionOverflowOn,
} from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalNameSegments";

export function hasSignalNameSelectionOverflow(
    selectionOverflowOn: SignalNameSelectionOverflow | undefined,
    target: SignalNameSelectionOverflowOn,
): boolean {
    if (!selectionOverflowOn) {
        return false;
    }

    return Array.isArray(selectionOverflowOn) ? selectionOverflowOn.includes(target) : selectionOverflowOn === target;
}
